import script from "./HrEmployeeForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrEmployeeForm.vue?vue&type=script&lang=ts&setup=true"

import "./HrEmployeeForm.vue?vue&type=style&index=0&id=54a24332&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a24332"]])

export default __exports__